import React from 'react'
import { useQuery, gql } from '@apollo/client'
import Box from '@material-ui/core/Box'
import LinearProgress from '@material-ui/core/LinearProgress'
import Unauthorized from 'components/unauthorized'
import Error from 'components/error'
import { PageHeader } from 'components/page-header'
import { useAuth } from 'lib/auth'
import AcademyCoachesListView from './academy-coaches-list-view'

const ACADEMY_COACHES_QUERY = gql`
  query GetAcademyCoaches {
    currentUser {
      attributes {
        ... on Coach {
          employments {
            role
            academy {
              id
              name
              slug
              employments {
                id
                role
                isImpersonatable
                coach {
                  id
                  name
                  email
                  coachProfile {
                    profilePhoto
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

const AcademyCoachesList = () => {
  const { data, loading, error } = useQuery(ACADEMY_COACHES_QUERY)

  if (loading) return <LinearProgress />
  if (error) return <Error error={error} />

  const ownedAcademies = data.currentUser.attributes.employments
    .filter(e => e.role === 'OWNER')
    .map(e => e.academy)

  return (
    <>
      {ownedAcademies.map(academy => (
        <AcademyCoachesListView
          key={academy.id || academy.slug}
          academy={academy}
        />
      ))}
    </>
  )
}

const AccountAcademyCoachesPage = () => {
  const { user, isCoach } = useAuth()
  if (!isCoach || !user.isAcademyOwner || user.isAssumed) {
    return <Unauthorized />
  }
  return (
    <>
      <PageHeader title="Academy Coaches" />
      <Box>
        <AcademyCoachesList />
      </Box>
    </>
  )
}

export default AccountAcademyCoachesPage
